import axios from 'axios';
import { fcoUrl } from '../../fcoModules/utilities';

// PRIVATE VARS/FUNCTIONS

// PUBLIC PROPERTIES

// PUBLIC METHODS
export const getCurrentShopNotes = () => axios.get(fcoUrl('/shop/notes'));

export const saveShopNote = (text, { requestId, dateTime = Date.now(), internal = true } = {}) =>
    axios.post(fcoUrl('/shop/notes'), { text, requestId, dateTime, internal });

export const getShopNotesById = (shopId, requestFlag) => {
    const urlStr = requestFlag && shopId !== '' ? `/admin/shopRequest/rest/${shopId}/notes` : `/shop/notes/${shopId}`;
    return axios.get(fcoUrl(`${urlStr}`));
};
export const saveShopNoteById = (shopId, text, requestFlag, { createDateTime = Date.now(), internal = true } = {}) => {
    if (requestFlag && shopId !== '') {
        return axios.post(fcoUrl(`/admin/shopRequest/rest/notes`), { text, requestId: shopId, createDateTime, internal });
    }
    return axios.post(fcoUrl(`/shop/notes/${shopId}`), { text, createDateTime, internal });
};

export const addNewShop = (formData) => axios.post(fcoUrl(`/admin/shopRequest/rest/`), formData);
export const saveShopPreferencesById = (shopId, formData, requestFlag, worksheetId) => {
    const urlStr = requestFlag ? '/admin/shopRequest/rest' : '/shop/savePreferences';
    const params = worksheetId ? { worksheetId } : {};
    return axios.put(fcoUrl(`${urlStr}/${shopId}`), formData, { params });
};
export const getShopDetailsById = (shopId = '', requestFlag, excludeManagers = false) => {
    const urlStr = requestFlag ? '/admin/shopRequest/rest' : '/shop/shopDetails';
    const params = { excludeManagers };
    return axios.get(fcoUrl(`${urlStr}/${shopId}`), { params });
};

export const selectShop = (shopId) => {
    const params = { key: shopId };
    axios.post(fcoUrl('/shop/shopprocess', { params }));
};

export const exchangeAuthTokensForShop = (newShopId, refreshToken) =>
    axios.post(fcoUrl(`/auth/rest/v2/exchange/${newShopId}`), null, { headers: { Authorization: `Bearer ${refreshToken}` } });

export const getEmployees = (shopId, search, page, sort) => axios.get(fcoUrl(`/shop/employeesList/${shopId}`), { params: { search, page, sort } });

export const getShopsByUserId = (userId) => axios.get(fcoUrl(`/shop/user/${userId}`));

export const getCurrentUserShops = () => axios.get(fcoUrl('/current/user/shops'));
